export const CheckoutSuccess = {
  description: 'Parabéns! Sua compra de matchcoins foi um sucesso.',
  createBattleButton: 'Criar uma Batalha',
  createTournamentButton: 'Criar um Torneio'
};
